import { createContext, FC } from 'react'
import { FolderFilterContextProviderProps, State } from './types'

export const FolderFilterContext = createContext<State>({
  treeState: null,
  reducers: null,
  selectedFolder: '/',
  onFolderSelected: (_: string) => {
    // do nothing
  },
})

export const FolderFilterContextProvider: FC<FolderFilterContextProviderProps> = ({
  children,
  treeState,
  reducers,
  selectedFolder,
  onFolderSelected,
}) => {
  return (
    <FolderFilterContext.Provider value={{ treeState, reducers, selectedFolder, onFolderSelected }}>
      {children}
    </FolderFilterContext.Provider>
  )
}
